'use client'

import Row from '@/components/content/common/Row'
import ComparisonRowThumbnail from '@/components/content/comparisons/root/ComparisonsRow'
import { usePageContext } from '@/components/content/common/PageContext'
import type { Comparison, Category } from '@/payload-types'
import type { TitleProps } from '@/components/content/common/Title'

type RelatedComparisonsProps = {
  title?: string
  buttons?: TitleProps['buttons']
  comparisons?: Pick<Comparison, 'id' | 'name' | 'comparisonApps' | 'tldr'>[]
  categoryId?: Category['id']
  theme?: 'light' | 'dark'
  tag?: TitleProps['tag']
}

export default function RelatedComparisons({
  title,
  buttons,
  comparisons = [],
  categoryId,
  theme = 'light',
  tag = 'span',
}: RelatedComparisonsProps) {
  const { switchFocus } = usePageContext()

  if (comparisons.length === 0) return null

  return (
    <Row
      header={{
        title: title ?? 'Related app comparisons',
        buttons: buttons
          ? buttons
          : [
              {
                label: 'See all',
                click: () => {
                  switchFocus('Comparison')
                },
              },
            ],
        theme: theme,
        tag,
      }}
      theme={theme}
    >
      {comparisons.slice(0, 3).map((comparison, index) => (
        <div key={index} className="w-11/12 shrink-0 xs:min-w-[325px] xs:shrink md:min-w-0">
          <ComparisonRowThumbnail
            comparison={comparison}
            invert={theme === 'dark'}
            preferredCategoryId={categoryId}
          />
        </div>
      ))}
    </Row>
  )
}
